// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BookOutlinedSvg from "@fishx/icons-svg/es/asn/BookOutlined";
import FishxIcon from '../components/FishxIcon';

var BookOutlined = function BookOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BookOutlinedSvg
  }));
};

BookOutlined.displayName = 'BookOutlined';
export default React.forwardRef(BookOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BookOutlined.js
// module id = 2081
// module chunks = 0